import React from 'react'
import { PrimaryButton } from 'components'

const Button = ({ disabled, ...rest }) => (
  <PrimaryButton
    disabled={disabled}
    style={
      !disabled && {
        color: '#000',
        background: `linear-gradient(177.65deg, #FFFFFF 1.96%, #C0CEFF 98.03%),linear-gradient(0deg, #FFFFFF, #FFFFFF),linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15))`,
      }
    }
    {...rest}
  />
)

export default Button
